import { useEffect, useState } from "react";
import styled from "styled-components";
import Poster from "../../../assets/images/hero/video-sample.png";
import FacebookIcon from "../../../assets/images/icons/facebook-icon.png";
import InstagramIcon from "../../../assets/images/icons/instagram-icon.png";
import TiktokIcon from "../../../assets/images/icons/tiktok-icon.png";
import LogoCircular from "../../../components/logo/LogoCircle";
import H1 from "../../../components/typography/H1";
import { videoService } from "../../../service/VideoService";
import colors from "../../../theme/color/ColorTheme";
import fontSize from "../../../theme/fonts/FontTheme";

const Wrapper = styled.div`
  width: 100%;
`;
const Container = styled.div`
  display: flex;
  gap: 40px;
  align-items: center;
  @media (max-width: 900px) {
    flex-direction: column;
    gap: 50px;
  }
`;

const Left = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  align-items: center;
  flex: 1;
  p {
    font-size: ${fontSize.s};
    max-width: 360px;
    width: 100%;
    color: ${colors.textMuted};
    text-align: center;
  }
`;

const Right = styled.div`
  flex-shrink: 0;
  img {
    height: 800px;
    width: 450px;
    object-fit: cover;
    max-width: 100%;
    height: auto;
  }
`;
const SocialLinks = styled.div`
  display: flex;
  gap: 12px;
  @media (max-width: 1300px) {
    flex-direction: column;
    gap: 20px;
  }
`;
const SocialLink = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  a {
    text-decoration: none;
    font-size: ${fontSize.l};
    color: ${colors.black};
  }
`;
const VideoWrapper = styled.div`
  z-index: 1 !important;
  margin: auto;
  video {
    height: 600px;
    max-width: 450px;
    width: 90vw;
    z-index: 99;
    object-fit: cover;
    margin: 0 auto;
    transition: transform 0.3s ease-out;
    border: none;
  }
`;
function SocialsSection() {
  const [videoPath, setVideoPath] = useState();

  useEffect(() => {
    const fetchVideo = async () => {
      videoService.getVideoLink(
        (data) => {
          setVideoPath(data[0].path);
        },
        {
          default: () => {
            setVideoPath(null);
          },
        }
      );
    };
    fetchVideo();
  }, []);
  return (
    <Wrapper>
      <Container>
        <Left>
          <LogoCircular height={"200px"} />
          <H1>FOLLOW US</H1>
          <p>
            To stay updated on new arrivals, collection launches and WALLET
            news.
          </p>
          <SocialLinks>
            <SocialLink>
              <img src={InstagramIcon} alt="" />
              <a href="https://www.instagram.com/walletmenswear">
                @walletmenswear
              </a>
            </SocialLink>
            <SocialLink>
              <img src={FacebookIcon} alt="" />
              <a href="https://www.facebook.com/profile.php?id=100070757382584">
                @walletmenswear
              </a>
            </SocialLink>
            <SocialLink>
              <img src={TiktokIcon} alt="" />
              <a href="https://www.tiktok.com/@walletmenswear">
                @walletmenswear
              </a>
            </SocialLink>
          </SocialLinks>
        </Left>
        <Right>
          {videoPath && (
            <VideoWrapper>
              <video
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                poster={Poster}
              >
                <source
                  src={process.env.REACT_APP_IMAGE_BASE_URL + videoPath}
                  type="video/mp4"
                />
              </video>
            </VideoWrapper>
          )}
        </Right>
      </Container>
    </Wrapper>
  );
}

export default SocialsSection;
